var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"table__row"},_vm._l((_vm.row),function(item,idx){return _c('li',{key:_vm.data.groupName + idx,staticClass:"table__col"},[_c('p',{staticClass:"table__text"},[_vm._v(_vm._s(_vm.data[item]))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }